export const IdentificationJsonSchema = {
  type: 'object',
  properties: {
    orderType: {
      type: 'string',
    },
    category: {
      type: 'string',
    },
    warehouseID: {
      type: 'string',
    },
    localOrderID: {
      type: 'string',
    },
    cartID: {
      type: 'string',
    },
    customerPONumber: {
      type: 'string',
    },
    referenceInvoiceID: {
      type: 'string',
    },
    customerRemarkNote: {
      type: 'string',
    },
  },
}

export const IdentificationUiSchema = {
  type: 'VerticalLayout',
  className: 'identification-filters',
  elements: [
    {
      type: 'HorizontalLayout',
      elements: [
        {
          type: 'Control',
          scope: '#/properties/orderType',
          component: 'ReadOnlyFieldWithJson',
          label: 'Order Type',
        },
        {
          type: 'Control',
          scope: '#/properties/localOrderID',
          component: 'ReadOnlyFieldWithJson',
          label: 'Local Order ID',
        },
        {
          type: 'Control',
          scope: '#/properties/customerPONumber',
          component: 'ReadOnlyFieldWithJson',
          label: 'Customer PO Number',
        },
      ],
    },
    {
      type: 'HorizontalLayout',
      elements: [
        {
          type: 'Control',
          scope: '#/properties/category',
          component: 'ReadOnlyFieldWithJson',
          label: 'Category',
        },
        {
          type: 'Control',
          scope: '#/properties/cartID',
          component: 'ReadOnlyFieldWithJson',
          label: 'Cart ID',
        },
        {
          type: 'Control',
          scope: '#/properties/referenceInvoiceID',
          component: 'ReadOnlyFieldWithJson',
          label: 'Reference Invoice ID',
        },
      ],
    },
    {
      type: 'Control',
      scope: '#/properties/warehouseID',
      component: 'ReadOnlyFieldWithJson',
      label: 'Warehouse ID',
    },
    {
      type: 'Control',
      scope: '#/properties/customerRemarkNote',
      component: 'ReadOnlyFieldWithJson',
      label: 'Customer Remark Note',
    },
  ],
}
